import React, { useCallback, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIdin } from '@verzekeringapp-mono/shared/src/hooks/use_idin'
import LoginScreenWrapper from '~/components/screen_wrappers/login_screen_wrapper'
import Register from './components/idin_register/Register'
import { logEvent } from '~/utils/firebase'

const IdinRegisterScreen: React.FC = () => {
  const { requestTransactionStatusWithToken } = useIdin()
  const location = useLocation()
  const navigate = useNavigate()

  const email = new URLSearchParams(location.search).get('email') ?? ''
  const entranceCode = new URLSearchParams(location.search).get('entranceCode') ?? ''
  const hasSentInitialRequest = React.useRef(false)
  const [error, setError] = React.useState<string | null>(null)

  useEffect(() => {
    if (email && entranceCode && !hasSentInitialRequest.current) {
      hasSentInitialRequest.current = true

      requestIdinStatus()
    }
  }, [])

  const requestIdinStatus = useCallback(() => {
    if (email && entranceCode) {
      requestTransactionStatusWithToken(entranceCode, email)
        .then((data) => {
          logEvent('idin_success')

          navigate(`/registration?email=${encodeURIComponent(email)}&token=${data.token}`)
        })
        .catch((error) => {
          logEvent('idin_error')
          setError(error.message || 'Er is een fout opgetreden tijdens het verwerken van iDIN. Probeer het opnieuw.')
        })
    }
  }, [email, entranceCode, requestTransactionStatusWithToken])

  return (
    <LoginScreenWrapper
      showHelpButton={false}
      helpButtonText='Wat is iDIN?'
    >
      <Register outsideError={error} />
    </LoginScreenWrapper>
  )
}

export default IdinRegisterScreen
